export default class Footer {
	/**
	 * @param {HTMLElement} element
	 */
	constructor(element) {
		this.elements = element.querySelectorAll(".js-Footer-copyItem");
		if (this.elements.length) {
			const randomItem =
				this.elements[Math.floor(Math.random() * this.elements.length)];
			randomItem.removeAttribute("hidden");
		}
	}
}
